"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBLESS_JWT_COOKIE_NAME = void 0;
var React = __importStar(require("react"));
var render_app_1 = __importDefault(require("../../utils/render-app"));
var app_1 = __importDefault(require("./app"));
var react_hooks_1 = require("@apollo/react-hooks");
var react_apollo_1 = require("react-apollo");
var subless_apollo_client_1 = __importDefault(require("../../utils/subless-apollo-client"));
var apolloClient = (0, subless_apollo_client_1.default)();
exports.SUBLESS_JWT_COOKIE_NAME = "sublessJwt";
(0, render_app_1.default)('magic-link-app', function (el) {
    var query = new URLSearchParams(window.location.search);
    var token = query.get('token');
    var destination = query.get('destination');
    var email = query.get('email');
    var jwt = query.get('jwt');
    var rhash = query.get('rhash');
    var csUser = query.get('user');
    var data = $(el).data();
    var props = { loadingAnimationPath: data.loadingAnimationPath, token: token, destination: destination, email: email, rhash: rhash, jwt: jwt, csUser: csUser };
    return (React.createElement(react_apollo_1.ApolloProvider, { client: apolloClient },
        React.createElement(react_hooks_1.ApolloProvider, { client: apolloClient },
            React.createElement(app_1.default, __assign({}, props)))));
});
